import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import http from '../../../../shared/http'
import { TApi, TRoutes } from '../../../../shared/const'

import Licence from './Licence'
import profil from '../Profile/style.module.scss'
import styles from './style.module.scss'

/**
 * Die Abschlusskarte im eigenen Profil.
 *
 * Sie steht dort und nicht auf einer eigenen Seite, weil sie dorthin gehört, wo
 * auch das Profilbild hinterlegt wird — die beiden hängen zusammen: Wer die
 * Schulung durchgeht, wird nach dem Bild gefragt, und wer sein Bild ändert,
 * sieht es auf der Abschlusskarte.
 *
 * Die Karte erscheint **immer**, auch vor dem ersten Durchgang. Ein Abschnitt,
 * der erst nach dem Abschluss auftaucht, wird nie zum Anlass, damit anzufangen.
 */
export default function ProfileCard() {
	const [stand, setStand] = useState(null)
	const [laedt, setLaedt] = useState(true)

	useEffect(() => {
		// Still: Eine nicht ladende Abschlusskarte ist kein Grund, über dem Profil
		// eine rote Meldung zu zeigen.
		http.get(TApi.ADMIN_TRAINING, { disableToast: true })
			.then(({ data }) => setStand(data))
			.catch(() => setStand(null))
			.finally(() => setLaedt(false))
	}, [])

	if (laedt) return null

	const begonnen = Boolean(stand?.startedAt)

	return (
		<div className={profil.section}>
			<h1 className={profil.sectionTitle}>Onboarding</h1>
			<div className={profil.sectionContent}>
				<Licence stand={stand} compact />

				<p className={styles.licenceNote}>
					{begonnen
						? 'Die Abschlusskarte zeigt euren letzten Stand. Weitermachen oder wiederholen geht jederzeit — das Abschlussdatum bleibt erhalten.'
						: 'Noch nicht begonnen. Das Onboarding führt in etwa 10 Minuten durch die Neuerungen des Schuljahrs 2026/27.'}
				</p>

				<Link className={styles.launchBtn} to={TRoutes.TRAINING}>
					{begonnen ? 'Zum Onboarding' : 'Onboarding starten'}
				</Link>
			</div>
		</div>
	)
}
